var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecorativeCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16.6562,
    width: 26.2861,
    height: 6,
    rx: 3,
    transform: "rotate(-39.3163 5 16.6562)",
    fill: "#06CEA8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.72266,
    y: 7,
    width: 13.6732,
    height: 6,
    rx: 3,
    transform: "rotate(51.8423 4.72266 7)",
    fill: "#D1EF54"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#DEFDBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeCheckmark);
export default __webpack_public_path__ + "static/media/decorative-checkmark.e5fe5f728cdfd2c018b22a92c7a8623e.svg";
export { ForwardRef as ReactComponent };